import { getServiceIcon } from '../../utils/serviceIcons';
import { getObjectColors } from '../../utils/objectColors';

interface Props {
  serviceName: string;
  serviceId?: string | null;
  className?: string;
}

export function ServicePill({ serviceName, serviceId, className = '' }: Props) {
  const Icon = getServiceIcon(serviceName);
  const colors = getObjectColors(serviceId ?? serviceName);
  const shortLabel = serviceName.split('-')[0].split(' ')[0];
  return (
    <span
      className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10.5px] font-medium ${className}`}
      style={{ background: colors.soft, color: colors.ink }}
      title={serviceName}
    >
      <Icon className="w-2.5 h-2.5" aria-hidden />
      <span className="truncate max-w-[8rem]">{shortLabel}</span>
    </span>
  );
}
